
import React, { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import Layout from '@/components/layout/Layout';
import EcommercePricesHeader from '@/components/ecommerce/EcommercePricesHeader';
import EcommercePricesTable from '@/components/ecommerce/EcommercePricesTable';
import EcommercePricesFilter from '@/components/ecommerce/EcommercePricesFilter';
import EcommercePriceForm from '@/components/ecommerce/EcommercePriceForm';
import EcommerceUpload from '@/components/ecommerce/upload/EcommerceUpload';
import { EcommercePriceFilters } from '@/types/database/ecommerce-prices';

const Ecommerce: React.FC = () => {
  const [filters, setFilters] = useState<EcommercePriceFilters>({});
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <Layout>
      <div className="container mx-auto p-6 space-y-6">
        <EcommercePricesHeader onRefresh={handleRefresh} />
        
        <Tabs defaultValue="view" className="w-full">
          <TabsList className="grid w-full grid-cols-3">
            <TabsTrigger value="view">View Prices</TabsTrigger>
            <TabsTrigger value="add">Add Price</TabsTrigger>
            <TabsTrigger value="upload">Upload Prices</TabsTrigger>
          </TabsList>
          
          <TabsContent value="view" className="space-y-4">
            <Card>
              <CardContent className="p-6">
                <EcommercePricesFilter 
                  filters={filters}
                  onFiltersChange={setFilters}
                />
              </CardContent>
            </Card>
            <EcommercePricesTable 
              filters={filters}
              refreshTrigger={refreshTrigger}
            />
          </TabsContent>
          
          <TabsContent value="add">
            <Card>
              <CardContent className="p-6">
                <EcommercePriceForm onSuccess={handleRefresh} />
              </CardContent>
            </Card>
          </TabsContent>
          
          <TabsContent value="upload">
            <Card>
              <CardContent className="p-6">
                <EcommerceUpload onSuccess={handleRefresh} />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
};

export default Ecommerce;
